// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"app-components-browse-recommendations--container","shelfWrapper":"app-components-browse-recommendations--shelfWrapper"};